export default "__VITE_ASSET__a63cc63a__"